import React, { useEffect, useState } from 'react'
import "./prizes.css"
import prizeGlass from "../../images/prizeGlass.png"
import prizeGarden from "../../images/prizeGarden.png"
import prizeVoucher from "../../images/prizeVoucher.png"
import desktopCar from "../../images/desktopCar.png"
import mobilePrizeGarden from "../../images/mobilePrizeGarden.png"
import mobilePrizeGlass from "../../images/mobilePrizeGlass.png"
import mobilePrizeVoucher from "../../images/mobilePrizeVoucher.png"
import fetchCars from '../../API/fetchCars'

const Prizes = () => {

  const [carsLeft, setCarsLeft] = useState(0)
  const [vouchersLeft, setVouchersLeft] = useState(0)


  useEffect(() => {
    let fetch = async () => {
      let response = await fetchCars()
      console.log(response)
      if (response?.data?.success) {
        setCarsLeft(response?.data?.success.data.carsLeft)
        setVouchersLeft(response?.data?.success.data.vouchersLeft)
      }
    }

    fetch()

  }, [])

  return (
    <div className="content prizesPage">
      <div className="title">ЗАЈЕЧАРСКО ВАС ЧАСТИ:</div>

      <div className="prizesContainer">

        <div className="prizeItem prize1">
          <div className="whiteContainer">
            <div className="number">1.</div>
            <img src={prizeGlass} className="desktopDisplay" />
            <img src={mobilePrizeGlass} className="mobileDisplay" />
          </div>

          <div className="text">
            <div className="textTitle">СВАКИХ САТ ВРЕМЕНА <br /> <br className="xsMobile" /> <span>СЕТ ЗА РОШТИЉ</span> </div>
            <div className="textInfo">
              Сет за роштиљ се састоји од: <br /> <br />
              <div>
                •  Три роштиљска елемента <br /> <br />
              </div>

              <div>
                • Футроле за роштиљске елементе
              </div>

            </div>
          </div>

        </div>


        <div className="prizeItem prize2">
          <div className="whiteContainer">
            <div className="number">2.</div>
            <img src={prizeGarden} className="desktopDisplay" />
            <img src={mobilePrizeGarden} className="mobileDisplay" />
          </div>

          <div className="text">
            <div className="textTitle">СВАКОГ ДАНА <br /> <span>КУХИЊСКИ ФРИЖИДЕР</span> </div>
            <div className="textInfo">
              Самостојећи кухињски фрижидер са замрзивачем доле марке LG <br /> <br />

              Модел GBV22L0EPY <br /> <br />

              Висина: 203цм <br /> <br />

              Ширина: 59,5цм <br /> <br />

              Боја: Сива <br /> <br />

              Енергетска класа: Е <br /> <br />
              

            </div>
          </div>


        </div>


        <div className="prizeItem prize3">
          <div className="whiteContainer">
            <div className="number">3.</div>
            <img src={prizeVoucher} className="desktopDisplay" />
            <img src={mobilePrizeVoucher} className="mobileDisplay" />
          </div>

          <div className="text">
            <div className="textTitle">СВАКИХ 7 ДАНА <br /> <span>ВАУЧЕР ОД 2000 ЕВРА <br /> ЗА ОПРЕМАЊЕ КУХИЊЕ</span> </div>

            <div className="textInfo">
              <div className="firstMargin">
                Ваучер је могуће искористити за куповину робe у објектима Техноманија, Техномедиа
                и Виторог. Целокупна понуда се може видети на сајту: <br />
                <a href="https://www.giftoncard.eu/zajecarsko-nagradna-igra" target="_blank">https://www.giftoncard.eu/zajecarsko-nagradna-igra</a>
              </div>   <br className="mobileDisplay" /> <br/>

              <div>
                Ваучер се може користити за више различитих куповина до укупног износа од 2000 евра.  <br />
                Уколико куповина прелази наведени износ, добитници сносе разлику.
              </div> <br className="mobileDisplay" /> <br/>

              <div className="label">
                <b>Број преосталих ваучера:</b>
                <div className="radioBtnHolder">
                  {parseInt(vouchersLeft) === 0 && <span style={{ marginLeft: "5px" }}>0</span>}
                  {parseInt(vouchersLeft) >= 1 && <div className="radioBtn"><div></div></div>}
                  {parseInt(vouchersLeft) >= 2 && <div className="radioBtn"><div></div></div>}
                  {parseInt(vouchersLeft) >= 3 && <div className="radioBtn"><div></div></div>}
                  {parseInt(vouchersLeft) >= 4 && <div className="radioBtn"><div></div></div>}
                  {parseInt(vouchersLeft) >= 5 && <div className="radioBtn"><div></div></div>}
                  {parseInt(vouchersLeft) >= 6 && <div className="radioBtn"><div></div></div>}
                  {parseInt(vouchersLeft) >= 7 && <div className="radioBtn"><div></div></div>}
                  {parseInt(vouchersLeft) === 8 && <div className="radioBtn"><div></div></div>}
                </div>

              </div>
            </div>
          </div>

        </div>


        <div className="prizeItem prize4">
          <div className="whiteContainer">
            <div className="number">4.</div>
            <img src={desktopCar} />
          </div>

          <div className="text">
            <div className="textTitle">СВАКИХ 14 ДАНА <br className="mobileDisplay" /> <span>АУТОМОБИЛ ШКОДА ОКТАВИЈА</span> </div>

            <div className="textInfo">
              <div className="infoPart">
                <span>КАРАКТЕРИСТИКЕ ВОЗИЛА <br /></span>
                Врста: Путничко  <br />
                Марка: Шкода  <br />
                Модел: Октавија А8 Селекшн 1.5ТСИ 6Г 85кв/115кс <br />
                Код возила: PV3DA5 <br />
                Земља порекла: Република Чешка  <br />
                Година производње: 2026 <br />
                Број врата: 5 <br />
                Број места за седење: 5 <br />
                Боја возила: Велвет црвена металик - К1К1 <br />
              </div>

              <div className="infoPart"> <br className="mobileDisplay" />
                <span>МОТОР</span> <br />
                Број цилиндара: 4 <br />
                Погонска осовина: предња <br />
                Укупна запремина (cm³): 1498 <br />
                Максимална снага Kw(KS): 85 <br />
                Максимални обртни моменат(Nm): 220/1500-3000  <br />
                Мењач: мануелни, 6 степени преноса + Р <br />
                Максимална брзина(km/h): 203 <br />
                Гориво: БМБ 95 <br />
                Ниво екологије: ЕУРО 6 <br />
                Емисија CO2(g/km):119 <br />
              </div>


              <div className="infoPart"> <br className="mobileDisplay" />
                <span>ПНЕУМАТИЦИ</span>  <br />
                Пнеуматици: 205/60 Р16 <br /> <br />

                <span>ПОТРОШЊА ГОРИВА</span> <br />
                (литара/100 km) <br />
                Градска: 7.1 <br />
                Ванградска: 4.5 <br />
                Комбинована: 5.2 <br />
                Резервоар за гориво <br /> (литара): 45 <br />

              </div>

              <div className='infoPart'> <br className='mobileDisplay' />
                <span>ДИМЕНЗИЈЕ</span> <br />
                Дужина(mm): 4698 <br />
                Ширина(mm): 1829 <br />
                Висина(mm): 1471 <br />
                Међуосовинско <br /> растојање(mm): 2669 <br />
                Запремина <br /> пртљажника (литара): <br /> 600 <br /> <br />
                <span>ТЕЖИНА</span> <br />
                Тежина празног возила <br /> (kg): 1351<br />
              </div>

            </div>

            <div className="carsLeft">
              <div className="label">
                Број аутомобила који је и даље у игри:
                <div className="radioBtnHolder">
                  {parseInt(carsLeft) === 0 && <span style={{ marginLeft: "5px" }}>0</span>}
                  {parseInt(carsLeft) >= 1 && <div className="radioBtn"><div></div></div>}
                  {parseInt(carsLeft) >= 2 && <div className="radioBtn"><div></div></div>}
                  {parseInt(carsLeft) >= 3 && <div className="radioBtn"><div></div></div>}
                  {parseInt(carsLeft) === 4 && <div className="radioBtn"><div></div></div>}
                </div>

              </div>
              <div className="outro">	*Сваки добитник аутомобила обавезно ће присуствовати тренингу о одговорној
                конзумацији који ће бити организован од стране компаније HEINEKEN Srbija</div>
            </div>
          </div>



        </div>

        <div className="lastText">Слике награда не морају одговарати стварним наградама</div>
      </div>
    </div>
  )
}

export default Prizes